import { format } from './DateFormatter';
import DateFormat from './EventListingDateFormat';

const defaultFormats = {
  // January 1, 1999
  [DateFormat.STANDARD_DATE]: 'MMMM D, YYYY',

  // Mon, Jan 8
  [DateFormat.WEEKDAY_DATE]: 'ddd, MMM D',

  // January 1999
  [DateFormat.MONTH]: 'MMMM YYYY',

  // Tuesday
  [DateFormat.WEEKDAY_LABEL]: 'dddd',

  // Tue
  [DateFormat.WEEKDAY_LABEL_ABBR]: 'ddd',

  // 11, Thursday January 2018
  [DateFormat.TABLE_CELL_ARIA_LABEL]: 'D, dddd MMMM YYYY',
};

let formats = defaultFormats;

function setDateFormats(settingFormats = {}) {
  formats = Object.assign({}, defaultFormats, settingFormats);
}

function standardDate(date) {
  return format(date, formats[DateFormat.STANDARD_DATE]);
}

function weekdayDate(date) {
  return format(date, formats[DateFormat.WEEKDAY_DATE]);
}

function month(date) {
  return format(date, formats[DateFormat.MONTH]);
}

function weekdayLabel(date) {
  return format(date, formats[DateFormat.WEEKDAY_LABEL]);
}

function weekdayLabelAbbreviated(date) {
  return format(date, formats[DateFormat.WEEKDAY_LABEL_ABBR]);
}

function tableCellAriaLabel(date) {
  return format(date, formats[DateFormat.TABLE_CELL_ARIA_LABEL]);
}

function getStandardDateFormat() {
  return formats[DateFormat.STANDARD_DATE];
}

export default {
  setDateFormats,
  getStandardDateFormat,
  standardDate,
  format,
  weekdayDate,
  month,
  weekdayLabel,
  weekdayLabelAbbreviated,
  tableCellAriaLabel,
};



// WEBPACK FOOTER //
// ./V7/events/listing/date/EventListingDateFormatter.js